import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import Loader from "../../components/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faRotate, faCircleArrowLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ModulePackForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [module, setModule] = useState([]);
    const [moduleId, setModuleId] = useState("");
    const [productType, setProductType] = useState([]);
    const [productTypeId, setProductTypeId] = useState("");
    const [numLicencias, setNumLicencias] = useState("");
    const [paymentPeriod, setPaymentPeriod] = useState("");
    const [isPay, setIsPay] = useState(0);
    const [maxCount, setMaxCount] = useState(0);
    const [descripcion, setDescripcion] = useState("");
    const [perUserDescription, setPerUserDescription] = useState("");
    const [dateLimit, setDateLimit] = useState(null);
    const [flagActive, setFlagActive] = useState(0);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss");
            setDateLimit(formattedDate);
        }
    };

    useEffect(() => {
        if (id) {
            const fetchModulePack = async () => {
                try {
                    setLoading(true);
                    const response = await apiClient.get(`/module_pack/${id}`);
                    if (response.status === 200) {
                        console.log(response.data[0])
                        setProductTypeId(response.data[0].productTypeId);
                        setModuleId(response.data[0].moduleId);
                        setNumLicencias(response.data[0].numLicencias);
                        setPaymentPeriod(response.data[0].paymentPeriod);
                        setIsPay(response.data[0].isPay ? 1 : 0);
                        setMaxCount(response.data[0].maxCount);
                        setDescripcion(response.data[0].description);
                        setPerUserDescription(response.data[0].perUserDescription);
                        setDateLimit(response.data[0].dateLimit);
                        setFlagActive(response.data[0].flagActive ? 1 : 0);
                    }
                } catch (error) {
                    console.error("Error al cargar el Módulo", error);
                } finally {
                    setLoading(false);
                }
            };
            fetchModulePack();
        }
        const fetchModules = async () => {
            try {
                setLoading(true);
                const modules = await apiClient.get(`/modules`);
                if (modules.status === 200) {
                    setModule(modules.data || []);
                }
            } catch (error) {
                console.error("Error al cargar los módulos", error);
            } finally {
                setLoading(false);
            }
        };
        fetchModules();
        const fetchProductTypes = async () => {
            try {
                setLoading(true);
                const pTypes = await apiClient.get(`/product_type`);
                if (pTypes.status === 200) {
                    setProductType(pTypes.data || []);
                }
            } catch (error) {
                console.error("Error al cargar los tipos de producto", error);
            } finally {
                setLoading(false);
            }
        };
        fetchProductTypes();
    }, [id]);

    const toggleSwitchFlag = () => {
        setFlagActive((prev) => (prev === 1 ? 0 : 1));
    };

    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const toggleSwitchPay = () => {
        setIsPay((prev) => {
            const newValue = prev === 1 ? 0 : 1;
            setMaxCount(newValue === 1 ? 999 : 0);
            return newValue;
        });
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!moduleId) validationErrors.moduleId = "El Campo es Obligatorio";
        if (!productTypeId) validationErrors.productTypeId = "El Campo es Obligatorio";
        if (!numLicencias) validationErrors.numLicencias = "El Campo es Obligatorio";
        if (numLicencias > 1000) validationErrors.numLicencias = "El valor debe ser menor a 1000";
        if (maxCount > 1000) validationErrors.numLicencias = "El valor debe ser menor a 1000";
        if (!paymentPeriod) validationErrors.paymentPeriod = "El Campo es Obligatorio";
        if (!descripcion) validationErrors.descripcion = "El Campo es Obligatorio";
        if (!perUserDescription) validationErrors.perUserDescription = "El Campo es Obligatorio";
        if (!dateLimit) {
            validationErrors.dateLimit = "El Campo es Obligatorio";
        } else {
            const selectedDate = new Date(dateLimit);
            if (isNaN(selectedDate.getTime())) {
                validationErrors.dateLimit = "Fecha inválida";
            }
        }
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            setLoading(true);
            if (id) {
                const payloadUpdate = {
                    numLicencias,
                    paymentPeriod,
                    isPay: isPay === 1,
                    maxCount,
                    descripcion,
                    perUserDescription,
                    dateLimit: format(new Date(dateLimit), "yyyy-MM-dd HH:mm:ss"),
                    flagActive: flagActive === 1
                };
                response = await apiClient.patch(`/module_pack/${id}`, payloadUpdate);
                console.log(response.data[0])
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    navigate("/ModulePackList");
                }
            } else {
                const payload = {
                    moduleId,
                    productTypeId,
                    numLicencias,
                    paymentPeriod,
                    isPay: isPay === 1,
                    maxCount,
                    descripcion,
                    perUserDescription,
                    dateLimit,
                    flagActive: flagActive === 1
                };
                response = await apiClient.post(`/module_pack`, payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    navigate("/ModulePackList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("MODULE_PACK_ALREADY_EXIST")) {
                setMessageBlock("El Módulo ya existe.");
                setNotificationBlock(true);
            } else if (error.response?.data?.message.startsWith("INVALID_DATE")) {
                setErrorMessage("La Fecha Ingresada es Inválida.");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            } else if (error.response?.data?.message.startsWith("moduleTemplate_ALREADY_EXISTS")) {
                setMessageBlock("La plantilla de módulo ya existe");
                setNotificationBlock(true);
            } else {
                setErrorMessage("¡Oops! Ocurrió un error al crear el Módulo");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Módulo" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ModulePackList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Módulo</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.moduleId ? "red" : "revert-layer" }}>
                            Módulo </label>
                        <select
                            value={moduleId}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setModuleId(selectedId);
                            }
                            } disabled={id !== undefined} >
                            <option value="">Seleccione una opción</option>
                            {module.map((mod) => (
                                <option key={mod.id} value={mod.id}>
                                    {mod.descripcion}
                                </option>
                            ))}
                        </select>
                        {errors.moduleId && <p className="error-message">{errors.moduleId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.productTypeId ? "red" : "revert-layer" }}>
                            Tipo de Producto </label>
                        <select
                            value={productTypeId}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setProductTypeId(selectedId);
                            }
                            } disabled={id !== undefined} >
                            <option value="">Seleccione una opción</option>
                            {productType.map((pType) => (
                                <option key={pType.id} value={pType.id}>
                                    {pType.code}
                                </option>
                            ))}
                        </select>
                        {errors.productTypeId && <p className="error-message">{errors.productTypeId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.numLicencias ? "red" : "revert-layer" }}>
                            Número de Licencias
                        </label>
                        <input
                            type="text"
                            placeholder="Número de licencias"
                            value={numLicencias}
                            //onChange={(e) => setNumLicencias(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setNumLicencias(value);
                                }
                            }}
                        />
                        {errors.numLicencias && <p className="error-message">{errors.numLicencias}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.paymentPeriod ? "red" : "revert-layer" }}>
                            Periodo de Pago
                        </label>
                        <input
                            type="text"
                            placeholder="Periodo de pago"
                            value={paymentPeriod}
                            //onChange={(e) => setPaymentPeriod(e.target.value)}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setPaymentPeriod(value);
                                }
                            }}
                        />
                        {errors.paymentPeriod && <p className="error-message">{errors.paymentPeriod}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Plan</label>
                            <div className="slider-container-contract" onClick={toggleSwitchPay}>
                                <div className={`slider-option-contract ${isPay === 1
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Pagado
                                </div>
                                <div className={`slider-option-contract ${isPay === 0
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Gratis
                                </div>
                            </div>
                        </div>
                    </div>
                    {(isPay || (maxCount !== 0)) && (
                        <>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.maxCount ? "red" : "revert-layer" }}>
                                    Número Máximo de Usuarios
                                </label>
                                <input
                                    type="text"
                                    placeholder="Número Máximo de Usuarios"
                                    value={maxCount}
                                    //onChange={(e) => setMaxCount(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d{0,3}$/.test(value)) {
                                            const numericValue = parseInt(value, 10);
                                            if (numericValue <= 999 || value === "") {
                                                setMaxCount(value);
                                            }
                                        }
                                    }}
                                />
                                {errors.maxCount && <p className="error-message">{errors.maxCount}</p>}
                            </div>
                        </>
                    )}

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.descripcion ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                        {errors.descripcion && <p className="error-message">{errors.descripcion}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.perUserDescription ? "red" : "revert-layer" }}>
                            Descripción por Usuario
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={perUserDescription}
                            onChange={(e) => setPerUserDescription(e.target.value)}
                        />
                        {errors.perUserDescription && <p className="error-message">{errors.perUserDescription}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.dateLimit ? "red" : "revert-layer" }}>
                            Fecha Límite{" "}
                        </label>
                        <div className="basic-info-date-picker">
                            <DatePicker
                                selected={dateLimit ? new Date(dateLimit) : null}
                                onChange={handleDateChange}
                                showTimeSelect
                                locale={es}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                placeholderText="Selecciona la Fecha"
                                className="custom-date-picker"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                            {errors.dateLimit && <p className="error-message">{errors.dateLimit}</p>}
                        </div>
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Estado</label>
                            <div className="slider-container-contract" onClick={toggleSwitchFlag}>
                                <div className={`slider-option-contract ${flagActive === 1
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Activo
                                </div>
                                <div className={`slider-option-contract ${flagActive === 0
                                    ? "active-contract"
                                    : "inactive-contract"}`}>
                                    Inactivo
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/ModulePackList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Módulo se ha Actualizado Correctamente."
                        : "El Módulo se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Módulo debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/ModulePackList"}
                    whatsApp={false} 
                />
            )}
            {loading && <Loader />}
        </div>
    );
};

export default ModulePackForm;